export const DataMutationMyBag_GiftcardApply_QueryKey = {
  mybagGiftcardApply: (): string => {
    const queryKey = "data-mutation-mybag-giftcard-apply";
    return queryKey;
  },
};
